import type { ApiClientConfig } from './types.js';

export function createHttpClient(config: ApiClientConfig) {
  const { baseUrl, getToken } = config;

  async function fetch(path: string, init: RequestInit = {}): Promise<Response> {
    const token = getToken();
    const headers = new Headers(init.headers);

    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    if (init.body && !headers.has('Content-Type') && !(init.body instanceof FormData)) {
      headers.set('Content-Type', 'application/json');
    }

    return globalThis.fetch(`${baseUrl}${path}`, { ...init, headers });
  }

  async function json<T>(path: string, init?: RequestInit): Promise<T> {
    const response = await fetch(path, init);
    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(
        (data as { error?: string }).error ?? `Request failed: ${response.status}`,
      );
    }

    return data as T;
  }

  return { fetch, json };
}

export type HttpClient = ReturnType<typeof createHttpClient>;
